import { useState } from 'react';
import { Link } from "react-router-dom";
import { Grid, Container,  Accordion, AccordionSummary, AccordionDetails, Card, Divider, Icon } from '@mui/material';
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const AccordionZone = ({data, parseContent, view}) => {
	const [expanded, setExpanded] = useState(false);
  const handleChangeOpen = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <div id="Accordion">
      <Container maxWidth="sm" sx={{my:4, py:4}} >  
				<div className="section-title" style={{textAlign:"center"}}>
						<h2>{data ? data.title : "...loading"}</h2>
				</div>
				<MDTypography color="light" component="div" variant="body2">{parseContent(data.text)}</MDTypography>
				<Divider sx={{width:"100%"}} />
				<div className="about-text">
				{data ? data.cards.map( (item,i) =>( 
					<Accordion  expanded={expanded === `panel-${i}`}  onChange={handleChangeOpen(`panel-${i}`)} key={`item-${i}`}>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls={`${item.type}-content`}
							id={`${item.type}-header`}
							sx={{"& .MuiAccordionSummary-content" :{my:3}, 
							backgroundColor: ({palette:{background}})=>background.header
						}}
							>  
							<MDTypography color="text"  variant="h5">{item.title}</MDTypography>	
							</AccordionSummary>
							<AccordionDetails sx={{backgroundColor:({palette:{background}})=>background.default}}>
								<Grid spacing={2} container>
								{item.cards && item.cards.length > 0 ? item.cards.map( (child,i) =>(
									<Grid xs={12} lg={item.view === "cards" ? 4 : 12} key={`child-item-${i}`} item>
										<Card sx={{p:{sm:1 , lg :2}}} >
											<Grid spacing={2} container >
												<Grid xs={12} lg={item.view === "cards" ? 12 : 3}  item>
													<MDBox component="img" sx={{objectFit:"cover", height:"100%", width:"100%"}} alt={child.title} src={`${process.env.REACT_APP_PUBLIC_URL}/img/${child.img.split("_")[0]}/${child.img}`} />
												</Grid>
												<Grid xs={12} lg={item.view === "cards" ? 12 : 9}   item>
													<MDTypography  variant="h6">{child.title}</MDTypography>
													<MDTypography sx={{fontSize:15}} component="div" variant="body2">{parseContent(child.text)}</MDTypography>
													<MDBox sx={{textAlign : item.view === "cards" ? "center" : "right"}}><Link className="custome-fancy-link-primary" to={child.link?.slug}>Details <Icon sx={{verticalAlign:"top"}} fontSize="lg">trending_flat</Icon></Link></MDBox>
												</Grid>
											</Grid>
										</Card>
									</Grid>
									)) : "...loading"}
								</Grid>
							</AccordionDetails>
						</Accordion>
					)) : "...loading!!"}
				</div>
      </Container>
    </div>
  );
};
export default AccordionZone;